export default function formatPrice(price) {
    if (isNaN(price) || price === null || price === undefined) {
      return "0"; // Default to "0" if the input is invalid
    }
  
    // Use parseInt to remove decimals, then format the number with commas
    return parseInt(price)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Format with commas
  }